import React, { useEffect, useState } from "react";

// components
import Footer from "../components/layout/footer/Footer";
import Navbar from "../components/layout/navbar/Navbar";
import { getAbonneInfo_allRight } from "../services/abonne/AbonneRequest";

const BaseLayout = (props) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const customerNumber = sessionStorage.getItem("customer_number")
      ? sessionStorage.getItem("customer_number")
      : "";
    getAbonneInfo_allRight(customerNumber)
      .then((res) => {
        setUser(res.data.donnee);
      })
      .catch((err) => {
        return err;
      });
  }, []);

  return (
    <div>
      <Navbar />
      {props.children}
    </div>
  );
};

export default BaseLayout;
